import React from 'react';
import NotFoundBlock from '../components/Not-found-block';

const NotFound: React.FC = () => {
  return <NotFoundBlock />;
};

export default NotFound;
